<template>
  <div class="login-spacing">
    <b-alert show v-if="displayMaintenanceWindow" variant="warning">
      <h4 class="alert-heading"><strong>Geplantes Wartungsfenster</strong></h4>
      <p class="mb-0">
        <strong>Am 30.01.2024 von 20:00 Uhr bis voraussichtlich 21:00 Uhr wird das eFörderportal nicht zur Verfügung stehen. Danke für Ihr Verständnis.</strong>
      </p>
    </b-alert>
    <h1>Melden Sie sich mit Ihrer E-Mail-Adresse an</h1>
    <div class="login-form-wrapper">

      <b-alert v-model="hasUnknownError" variant="danger">
        {{ unknownErrorMessage }}
      </b-alert>

      <b-alert v-model="hasError" variant="danger">
        {{ errorMessage }}
      </b-alert>

      <validation-observer ref="observer" v-slot="{ passes }">
        <b-form @submit.prevent="passes(onSubmit)" @reset.prevent="reset">

          <validation-provider vid="email" rules="required|email" name="Email" v-slot="{ valid, errors, changed }">
            <b-form-group id="input-group-email" label="E-Mail" label-for="input-email">
              <b-form-input
                id="input-email"
                v-model="form.email"
                :state="onValidateField(valid, errors, changed)"
                type="email"
                placeholder="E-Mail angeben"
              ></b-form-input>
              <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider vid="password" rules="required|min:5" name="Password" v-slot="{ valid, errors, changed }">
            <b-form-group id="input-group-password" label="Passwort" label-for="input-password">
              <b-form-input
                id="input-password"
                v-model="form.password"
                :state="onValidateField(valid, errors, changed)"
                type="password"
                placeholder="Passwort angeben"
              ></b-form-input>
              <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <b-button type="submit" variant="primary" class="w-100" disabled v-if="isSubmitting">
            <b-spinner small></b-spinner>
            Anmelden
          </b-button>
          <b-button type="submit" variant="primary" class="w-100" v-else>Anmelden</b-button>
        </b-form>
      </validation-observer>
    </div>
    <p>
      <router-link to="/passwort-vergessen">Passwort vergessen?</router-link>
    </p>
    <h1>Noch kein Benutzerkonto?</h1>
    <p>
      <router-link to="/registrieren">Jetzt neues Benutzerkonto anlegen</router-link>
    </p>
    <h1>
      Fördergeldrechner
    </h1>
    <p>
      <router-link to="/foerdergeldrechner">Zum Fördergeldrechner</router-link>
    </p>
    <ul class="agb-links">
      <li>
        <a class="modallink" @click="openModal('kontakt')">Kontakt</a>
      </li>
      <li>
        <a class="modallink" @click="openModal('agb')">Nutzungsbedingungen</a>
      </li>
      <li>
        <a class="modallink" @click="openModal('datenschutz')">Datenschutz</a>
      </li>
      <li>
        <a class="modallink" @click="openModal('impressum')">Impressum</a>
      </li>
    </ul>
    <modalagb :showContent="showContent" :modalTitle="modalTitle"/>
    <cookie-law theme="dark-lime" buttonText="Akzeptieren">
      <div slot="message">
        Diese Webseite verwendet Cookies. Das eFörderportal verwendet Cookies, um die Webseite bestmöglich an die
        Bedürfnisse unserer Besucher anpassen zu können. Bei Verwendung der eFörderportal Webseite stimmen Sie zu, dass
        Cookies auf Ihrem Computer gespeichert werden. <a v-on:click="openModal('datenschutz')" v-b-modal.modal-scrollable-nb>Weitere Infos</a>
      </div>
    </cookie-law>
  </div>
</template>

<script>
  import { ValidationObserver, ValidationProvider } from 'vee-validate'
  import { errorHandler, validateField } from '@/helpers/formHelper.js'
  import modalagb from '@/components/login/Modal'
  import CookieLaw from 'vue-cookie-law'

  const getInitialData = () => ({
    form: {
      email: '',
      password: ''
    }
  })

  export default {
    components: {
      ValidationObserver,
      ValidationProvider,
      modalagb,
      CookieLaw
    },
    data: () => ({
      isSubmitting: false,
      hasUnknownError: false,
      unknownErrorMessage: '',
      hasError: false,
      errorMessage: '',
      showContent: '',
      modalTitle: '',
      ...getInitialData()
    }),
    mounted () {
      const { path } = this.$route

      if (path && path.length > 1) {
        this.openModal(path.substring(1))
      }
    },
    methods: {
      async onSubmit () {
        this.isSubmitting = true
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('user/LOGIN', this.form).then(res => {
          const { errors } = res

          if (errors) {
            const error = errors[0].extensions

            if (error.code === 'SMS_BLOCKED' || error.code === 'USER_LOCKEDOUT') {
              this.hasError = true
              this.errorMessage = this.$t(`formError.${error.i18n}`)
              this.isSubmitting = false
              return
            }

            this.isSubmitting = false
            return errorHandler(this, errors)
          }
          this.isSubmitting = false
        }).catch(err => {
          this.isSubmitting = false
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      },
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      },
      reset () {
        Object.assign(this.$data, getInitialData())
        requestAnimationFrame(() => {
          this.$refs.observer.reset()
        })
      },
      openModal (modal) {
        if (modal === 'agb') {
          this.showContent = 'agb'
          this.modalTitle = 'Nutzungsbedingungen'
        } else if (modal === 'datenschutz') {
          this.showContent = 'datenschutz'
          this.modalTitle = 'Datenschutz-Bestimmungen'
        } else if (modal === 'kontakt') {
          this.showContent = 'kontakt'
          this.modalTitle = 'Kontakt'
        } else if (modal === 'impressum') {
          this.showContent = 'impressum'
          this.modalTitle = 'Impressum'
        } else {
          this.showContent = ''
          this.modalTitle = ''
        }

        this.$root.$emit('bv::show::modal', 'modal-scrollable-nb', '.modallink')

        this.$router
          .push({
            path: `/${modal}`
          })
          .catch(() => {})
      }
    },
    computed: {
      displayMaintenanceWindow () {
        const currentDateTime = new Date()
        const endMaintenance = new Date(2024, 0, 30, 21, 0, 0)
        let showWindow = false
        if (currentDateTime < endMaintenance) {
          showWindow = true
        }
        return showWindow
      }
    }
  }
</script>

<style lang="scss" scoped>
  .login-spacing{
    margin-top: 7rem;
  }
  .login-form-wrapper{
    max-width: 320px;
    margin: 0 auto;
  }

  .agb-links{
    @include list-unstyled;
    margin-top: 5rem;

    li{
      padding-right: 15px;
      padding-left: 15px;
      display: inline-block;

       .modallink{
        text-decoration: underline;
        cursor: pointer;
       }
    }
  }

    .Cookie{
      background-color: $gray;
    }

    .Cookie__content{
      font-size: 0.75rem !important;

      a{
        color: $green;

        &:hover{
          color: $green;
        }
      }
    }
</style>
